/**
 * Created by AlexanderC on 5/25/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MethodsNotImplementedException = undefined;

var _Exception2 = require('./Exception');

var _InvalidArgumentException = require('./InvalidArgumentException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when methods from interface or abstract class are not implemented
 */
let MethodsNotImplementedException = exports.MethodsNotImplementedException = function (_Exception) {
  _inherits(MethodsNotImplementedException, _Exception);

  /**
   * @param {Array} methods
   */
  function MethodsNotImplementedException(methods) {
    _classCallCheck(this, MethodsNotImplementedException);

    if (!Array.isArray(methods)) {
      throw new _InvalidArgumentException.InvalidArgumentException(methods, 'Array');
    }

    let methodPlain = methods.join(', ');

    return _possibleConstructorReturn(this, (MethodsNotImplementedException.__proto__ || Object.getPrototypeOf(MethodsNotImplementedException)).call(this, `One or more method are not implemented (${methodPlain}).`, 500));
  }

  return MethodsNotImplementedException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/Exception/MethodsNotImplementedException.js
// module id = 166
// module chunks = 0